import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CommonSelect from "../common/commonSelect";
import CommonTagsInput from "../common/Taginput";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../data/redux/store";
import { fetchTaskDataAction, saveTaskAction, updateFileAction } from "../data/redux/actions/TaskActions";
import moment from "moment";
import CommonTextEditor from "../common/textEditor";
import { DatePicker } from "antd";
import TaskRepetition from "./ticketRepitionModal";
import Select from "react-select";
import dayjs from "dayjs";
import MediaUpload from "./mediaUploader";
interface Props {
  task?: any
}
const MediaUploadModal: React.FC<Props> = ({ task }) => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [data, setData] = useState({
    ...task,
    files: [],
    audios: [],
    images: [],
    videos: [],
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (validateTask()) {
      const formData = new FormData();
      formData.append(`taskId`, task.id);
      let updatedTaskFiles: { file: any; type: string }[] = [];
      (data.files || []).forEach((file: any) => {
        updatedTaskFiles.push({ file, type: "document" });
      });
      (data.audios || []).forEach((file: any) => {
        updatedTaskFiles.push({ file, type: "audio" });
      });
      (data.images || []).forEach((file: any) => {
        updatedTaskFiles.push({ file, type: "image" });
      });
      (data.videos || []).forEach((file: any) => {
        updatedTaskFiles.push({ file, type: "video" });
      });
      updatedTaskFiles.forEach((taskFile, index) => {
        formData.append(`taskFiles[${index}].file`, taskFile.file);
        formData.append(`taskFiles[${index}].type`, taskFile.type);
      });
      dispatch(updateFileAction(formData));
    }
  };
  const validateTask = () => {
    let validRequest = true;
    let newErrors: Record<string, string> = {};
    const allowedFileTypes = [
      "image/png",
      "image/jpeg",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    const maxFileSize = 1 * 1024 * 1024;

    (data.files || []).forEach((file: File) => {
      if (!allowedFileTypes.includes(file.type)) {
        newErrors.files = "Invalid file type for attachment.";
        validRequest = false;
      } else if (file.size > maxFileSize) {
        newErrors.files = "File size for attachment must not exceed 1 MB.";
        validRequest = false;
      }
    });

    setErrors(newErrors);
    return validRequest;
  };
  return (
    <>
      {/* Add Ticket */}
      <div className="modal fade" id="add_files" data-bs-backdrop="static" data-bs-keyboard="false">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Upload File(s)</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form className="needs-validation" noValidate>
              <div className="modal-body">
                <div className="row">
                  <MediaUpload data={data} setData={setData} />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Add Ticket */}
    </>
  );
};

export default MediaUploadModal;
